<template>
  <v-container :class="['mx-auto']" style="max-width: 1340px">
  
<v-card> 
   
    <v-data-table
   :headers="headers"
   fixed-header
   height="500"
   dense
    :items="dataItems"
    :items-per-page="15"
    :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-arrow-left-thick',
      lastIcon: 'mdi-arrow-right-thick',
      prevIcon: 'mdi-minus-circle-outline',
      nextIcon: 'mdi-plus-circle-outline'
    }"
    :search="search"
  >
  <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>Consultar Logs de Mantenimeintos en www.domosa.com</v-toolbar-title>
        <v-spacer></v-spacer>
         <v-card-title>
       
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        clearable
        hide-details
      ></v-text-field>
    </v-card-title>
      </v-toolbar>
  </template>
  </v-data-table>
  </v-card>
      
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
        search: '',
      headers: [
        {
          text: "Fecha Log",
          align: "start",
          sortable: true,
          value: "fecha",
          class: "primary--text text--darken-2 body-1 font-weight-bold",
          
        },
        {
          text: "Url",
          align: "start",
          sortable: true,
          value: "url",
          class: "primary--text text--darken-2 body-1 font-weight-bold",
        },
         {
          text: "Accion",
          align: "start",
          sortable: true,
          value: "action",
          class: "primary--text text--darken-2 body-1 font-weight-bold",
          
        },
         {
          text: "Usuario",
          align: "start",
          sortable: true,
          value: "user",
          class: "primary--text text--darken-2 body-1 font-weight-bold",
        },
      ],
    };
  },
  watch: {
    validaUser() {
      this.validaUser;
    },
  },
  created() {
    this.initialize();
    this.clr_Logs_items();
  },
  methods: {
    ...mapMutations(["clr_Logs_items", "set_Logs_items"]),
    async initialize() {
      let that = this;
      const URL = `${this.dirPHP}getlog.php`;
      await this.axios
        .get(URL, {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        })
        .then(function(response) {
          response.data.forEach(function(data) {
            that.set_Logs_items(data);
          });
        });
    },
  },
  computed: {
    ...mapState(["dataUser", "dirPHP", "Logs_items"]),
    dataItems() {
      //let arregloDeTerminos = this.Logs_items.split('|');
      // console.log(arregloDeTerminos)
      let data = []

      if (this.Logs_items) {
        this.Logs_items.forEach((item) => {
            
          data.push({
              fecha: item.log.split("|")[0],
              url: item.log.split("|")[1],
              action: item.log.split("|")[2],
              user: item.log.split("|")[3],
          })
        });
      }
      return data;
    },
    validaUser() {
      if (this.dataUser.IndAutenticado) return true;
      else {
        this.$router.push({ path: `/` }).catch((err) => {});
        return false;
      }
    },
  },
};
</script>
